import { Link } from 'react-router-dom'

export function InviteExpiredPage() {
  return (
    <div className="min-h-screen flex items-center justify-center p-6" style={{ background: '#F5F2EA' }}>
      <div className="max-w-md text-center">
        <h1 className="text-lg font-semibold text-ink" style={{ fontFamily: 'Georgia, serif' }}>
          Invite expired
        </h1>
        <p className="text-sm text-ink-muted mt-2 leading-relaxed">
          Ask your admin to send a new invite from Duva Settings → Team Members.
        </p>
        <Link to="/login" className="text-sm text-brand-teal font-medium mt-5 inline-block hover:underline">
          Back to sign in
        </Link>
      </div>
    </div>
  )
}
